import axios from "axios";
import { IAvailableSPVoice } from "../Types/account";
import { getUserFromLS } from "../utils/getUserFromLS";
import { getTutorialAvailableSPVoices } from "./tutorialFixtureResponses";

export const getAvailableSPVoices = (callback: (response: IAvailableSPVoice[]) => void, errorCallback) => {
    const fixture = getTutorialAvailableSPVoices();
    if (fixture) {
        if (callback != null) {
            callback(fixture);
        }
        return Promise.resolve(fixture);
    }

    const user = getUserFromLS()
    const URL = `${import.meta.env.VITE_API_BASE_URL}/social-prompt-preferences/available-voices`;
    return axios(URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${user.access_token}`
      }
    })
        .then((response) => {
        if (callback != null) {
            callback(response.data as IAvailableSPVoice[]);
        }
        })
        .catch((error) => {
        // catch error
        if (errorCallback != null) {
            errorCallback(error);
        }
    });
};
